import { Component } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { connect } from 'react-redux';

import Form from 'components/atoms/Form';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import ToggleButton from 'components/atoms/ToggleButton';
import { OpenModal, PortType, RootState, UserCommentType, UserType } from 'types';
import { ActionsType } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent } from 'utils/formHandlers';
import { translate } from 'utils/translate';
import { userTypeForPort } from 'utils/permission';

interface CommentsTabProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    actions: ActionsType | undefined;

    //unused props
    errors?: any;

    many: boolean;
    comments?: UserCommentType[];
    setComment: (comment: string, type: string) => void;
    editComment?: (comment: UserCommentType) => void;
    refreshComments?: () => void;
    comment: UserCommentType;
    user: UserType;

    //unused props
    port: PortType;

    dateTimeFormat: DateTimeFormat;
    openModelFunction: OpenModal;
}

interface CommentsTabState {
    comment: UserCommentType;
    comments: UserCommentType[];
}

class CommentsTab extends Component<CommentsTabProps, CommentsTabState> {
    constructor(props: CommentsTabProps) {
        super(props);
        this.state = { comment: props.comment, comments: [] };
    }

    static getDerivedStateFromProps(props: CommentsTabProps, state: CommentsTabState) {
        if (checkDifferent(props.comment, state.comment) || checkDifferent(props.comments, state.comments)) {
            return {
                comment: props.comment,
                comments: props.comments,
            };
        }

        return null;
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onCancel();
    };

    //unused function
    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    togglDeleteComment = (id?: number) => {
        this.props.openModelFunction(
            'userDeleteCommentModel',
            0,
            'medium',
            { id: id },
            {
                onCancel: () => {
                    this.props.openModelFunction('userDeleteCommentModel');
                },
                onConfirm: this.props.refreshComments,
            }
        );
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className=" w-full rounded">
                    {this.props.many ? (
                        <div>{translate('Add a comment to the selected transits')}</div>
                    ) : (
                        <div>{translate('Read and/or add comments to this transit')}</div>
                    )}
                    <div className="my-2 ">
                        {this.state?.comments?.length === 0 ? (
                            <div className="text-center  z-10 h-full overflow-hidden">
                                <Image
                                    alt={translate(' No comments yet')}
                                    className="m-auto mb-3"
                                    src="/static/images/no-comments.png"
                                />
                                <p>{translate(' No comments yet')}</p>
                            </div>
                        ) : (
                            <Scrollbars style={{ height: 200 }}>
                                <>
                                    {this.state?.comments
                                        ?.filter((comment) => {
                                            return comment.user_id == this.props.user.id || comment.type === 'public';
                                        })
                                        .map((comment, index) => (
                                            <div key={index} className="pb-5 pr-4 w-full flex justify-between ">
                                                <div>
                                                    <div
                                                        dangerouslySetInnerHTML={{ __html: comment.text }}
                                                        className="leading-5 text-gray-500"
                                                    ></div>

                                                    <div className="flex gap-2 leading-4">
                                                        {comment.type !== 'private' && (
                                                            <Icon className="w-3 h-3 mt-1 ">
                                                                <path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                                                                <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                                                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                                                <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
                                                            </Icon>
                                                        )}
                                                        <div className="text-sm font-bold">{`${comment?.user?.first_name} ${comment?.user?.last_name}`}</div>
                                                        <div className="text-sm">
                                                            {this.props.dateTimeFormat
                                                                .parseDateTime(comment.created_at)
                                                                .formatDateTimeToString('dd LLL yyyy MM yyyy HH:mm')}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="">
                                                    {this.props.user && comment.user_id == this.props.user.id && (
                                                        <div className="flex gap-2">
                                                            <div
                                                                onClick={() => {
                                                                    //@ts-ignore
                                                                    this.props?.editComment(comment);
                                                                }}
                                                            >
                                                                <Icon className="w-4 h-4 mt-2 cursor-pointer">
                                                                    <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path>
                                                                    <path d="M13.5 6.5l4 4"></path>
                                                                    <path d="M16 19h6"></path>
                                                                </Icon>
                                                            </div>
                                                            <div
                                                                onClick={() => {
                                                                    this.togglDeleteComment(comment?.id);
                                                                }}
                                                            >
                                                                <Icon className="w-4 h-4 mt-2 cursor-pointer text-primary-delete">
                                                                    <path d="M4 7l16 0"></path>
                                                                    <path d="M10 11l0 6"></path>
                                                                    <path d="M14 11l0 6"></path>
                                                                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                                                                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                                                                </Icon>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                </>
                            </Scrollbars>
                        )}
                    </div>
                    <FormGroup className="short" horizontal={false}>
                        <ReactQuill
                            modules={{
                                toolbar: [
                                    [{ size: ['medium', false, 'large', 'huge'] }],
                                    ['bold', 'italic', 'underline'],
                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                    [{ align: [] }],

                                    ['clean'],
                                ],
                            }}
                            formats={[
                                'header',
                                'size',
                                'bold',
                                'italic',
                                'underline',
                                'strike',
                                'blockquote',
                                'list',
                                'bullet',
                            ]}
                            value={this.state.comment.text || ''}
                            onChange={(value) => {
                                const temp = this.state.comment;
                                temp.text = value;
                                this.props.setComment(value, this.state.comment.type);
                            }}
                        />
                    </FormGroup>
                    {userTypeForPort(this.props.user, this.props.port.id) !== 'guest' ? (
                        <div className="mt-5 flex items-center gap-1">
                            <div className="flex items-center align-middle">
                                <ToggleButton
                                    onChange={(name, value) => {
                                        this.props.setComment(this.state.comment.text, value ? 'public' : 'private');
                                    }}
                                    name="type"
                                    value={this.state.comment.type === 'public'}
                                ></ToggleButton>{' '}
                            </div>
                            <div className="flex items-center gap-2  ">
                                <div>{translate('Make this comment available for all users')}</div>
                                <Icon className="w-4 h-4">
                                    <path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"></path>
                                    <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                    <path d="M21 21v-2a4 4 0 0 0 -3 -3.85"></path>
                                </Icon>
                            </div>
                        </div>
                    ) : (
                        <div className="mt-5 flex items-center gap-1 text-red-500">
                            {translate('You cannot create shared comment')}
                        </div>
                    )}
                </Form>
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    dateTimeFormat: state.port.dateTimeFormat,
    user: state.user.user,
    port: state.port.port,
    openModelFunction: state.layout.openModelFunction,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CommentsTab);
